// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ActionButton-module-button-3KI-T{background-color:rgba(0,0,0,0);cursor:pointer;padding:12px}.ActionButton-module-button-3KI-T:focus-visible{border-radius:var(--des-radius-button);outline:var(--des-dimension-stroke-focus) solid var(--des-color-stroke-focus)}", ""]);
// Exports
exports.locals = {
	"button": "ActionButton-module-button-3KI-T"
};
module.exports = exports;
